<template>
  <div>
    <slider></slider>
    <categories></categories>
    <div class="row bg-cat" :style="'background: url(' + bg() + '); margin: 0; color:#fff; min-height:100vh; padding: 30px 0 50px 0;'">
      <div class="container">
        <div class="row">

          <div class="col-md-3" id="cartWidth">
            <cart></cart>
          </div>

          <div class="col-md-9">
            <products></products>
          </div>

        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import _ from "lodash";
  import categories from './categories'
  import slider from './slider'
  import cart from './cart'
  import products from './products'


  export default {
    components: {
      'categories': categories,
      'slider': slider,
      'cart': cart,
      'products': products,
    },
    computed: {
      state() {
        return this.$store.state
      }
    },
    methods: {
      bg() {
        var vm = this;
        return vm.state.config.url + vm.state.config.img_url + vm.state.config.id + '/' + vm.state.info.background;
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/components/Home/home.vue